module.exports = __webpack_public_path__ + "img/A_illustration.6626b87d.gif";